import {dateTimeLocalInputValue,timestampDateOnlyValue} from '../dates';

function londonMidnight(day:string){
 const utc=Date.parse(`${day}T00:00:00.000Z`),local=dateTimeLocalInputValue(new Date(utc));
 return new Date(utc-Number(local.slice(11,13))*3600000-Number(local.slice(14,16))*60000).toISOString();
}
/** Today's London midnight through the next 30 calendar days, including today's all-day entries. */
export function buildingCalendarWindow(now=new Date()){
 const first=timestampDateOnlyValue(now),start=Date.parse(`${first}T00:00:00.000Z`);
 const last=new Date(start+29*86400000).toISOString().slice(0,10),end=new Date(start+30*86400000).toISOString().slice(0,10);
 return {from:londonMidnight(first),to:londonMidnight(end),first,last};
}

/** Scoped attention links must remain internal and must not switch to another building. */
export function isBuildingAttentionPath(path:unknown,building:string):path is string {
 if(typeof path!=='string'||!path.startsWith('/')||path.startsWith('//')||path.includes('\\'))return false;
 const url=new URL(path,'https://staff.invalid');
 const own=/^\/buildings\/([^/]+)(?:\/|$)/.exec(url.pathname)?.[1];
 return url.origin==='https://staff.invalid'&&!url.pathname.startsWith('/portal')&&!url.pathname.startsWith('/procurement/respond')&&
  (!own||own==='areas'||own===building)&&['building','developmentId'].every(key=>url.searchParams.getAll(key).every(value=>value===building));
}
